export const lang = {
  VIEW: "View",
  DELETE: "DELETE",
  SEND: "SEND",
  SEE_REMARK: "See Remark",
  REMARK: "Remark",
  FROM: "From",
  TO: "To",
  PLAN: "Plan",
  EXTRA_INTEREST: "Extra Interest",
  TRUE: "Yes",
  FALSE: "No",
  EMAIL: "email",
  NO_HEADER: "NO_HEADER",
  USER_DATA: "USER_DATA",
  ROLE_LIST: "roleList",
  USER_KEY: "User-Key",
  SECURITY_TOKEN: "token",
  PORTAL_TYPE: "portalType",
  MAJOR_VERSION: "majorVersion",
  LOAN_APP_ID_LABEL: "Loan ID",
  EMAIL_LABEL: "Email ID",
  MOBILE_NUMBER_LABEL: "Mobile No",
  MOBILE_NO_LABEL: "Mobile No",
  AVAILABLE: "Available",
  ROWS_PER_PAGE: [10],
  LOG_OUT: "Logout",
  PROFILE: "Profile",
  CANCEL: "CANCEL",
  SAVE: "SAVE",
  NULL: "null",
  MANAGER_CLARIFICATION: "Manager-Clarification-Required",
  CUSTOMER_CLARIFICATION: "Customer-Clarification-Required",
  OPEN_APP: "Open App",
  CALL: "CALL",
  CALLS: "Calls",
  APPLY: "APPLY",
  FILTER: "Filter",
  RESET: "Reset",
  ON_HOLD: "On Hold",
  NOT_ON_HOLD: "Not on Hold",
  AMOUNT: "Amount",
  HOLD_REASONS: "Hold Reasons",
  PASCAL_SAVE: "Save",
  PASCAL_CALL: "Call",
  CLEAR: "Clear",
  ISSUE_DETAILS: "Issue Details",
  QUEUED_DATE: "Queued Date",
  APPLICATION_ID: "Application ID",
  COMMENT: "Comment",
  COMMENTS: "Comments",
  CONFIRM: "CONFIRM",
  MANUAL_ISSUE: "Manual Issue",
  TECH_ISSUE: "Tech Issue",
  SAVE_SUCCESS_TEXT: "The changes have been saved successfully",
  VIEW_ISSUE_ACTION: "View Issue Details",
  REVIEW: "Review",
  REASSIGN_OSV: "Reassign for OSV",
  NOT_ASSIGNED: "Not Assigned",
  QUEUES: "Queues",
  AGENT_MAPPING: "Agent Mapping",
  AGENT_LIST: "Agent List",
  NAME: "Name",
  UNASSIGN_AGENT: "Unassign Agents",
  ASSIGN_AGENT: "Assign Agents",
  UNASSIGN_FROM: "Unassign from",
  ASSIGN_TO: "Assign To",
  UNASSIGN: "UNASSIGN",
  ASSIGN: "ASSIGN",
  BULK_ACTION: "BULK ACTION",
  AGENT_ASSIGNED_SUCCESS: "Agent successfully assigned to queues.",
  AGENT_UNASSIGNED_SUCCESS: "Agent successfully Un-Assigned from queues.",
  BACK: "Back",
  HOME: "Home",
  NO_AGENTS: "No agents",
  NO_AGENT_SELECTED: "No agent selected",
  NO_AGENT_DESC: "Please search and add agents",
  NO_AGENT_DES: "Please search and add agent",
  FEEDBACK: "Feedback",
  EDIT_FEEDBACK: "Edit Feedback",
  SUBMIT: "Submit",
  SAVE_AND_VALIDATE: "Save & Validate",
  END_CALL: "End Call",
  VIEW_HISTORY: "View History",
  LAST_NON_PAYMENT_REASON: "Last Non Payment Reason",
  VIEW_ADDITIONAL_NUMBERS: "View All",
  ALLOCATE: "Allocate",
  RE_ALLOCATE: "Re-allocate",
  FATHER_NAME: "Father Name",
  MOTHER_NAME: "Mother Name",
  CURRENT_ADDRESS: "Current Address",
  PERMANENT_ADDRESS: "Permanent Address",
  MOBILE_NUMBER: "Mobile Number",
  ALTERNATE_NUMBER: "Other Contact",
  EMAIL_ID: "Email ID",
  BIRTH_YEAR: "Birth Year",
  MARITAL_STATUS: "Marital Status",
  EDUCATION_LEVEL: "Education Level",
  VIEW_LESS: "View Less",
  VIEW_MORE: "View More",
  EMPLOYER_DETAILS: "Employer Details",
  EMPLOYER_NAME: "Employer Name",
  EMPLOYER_TYPE: "Employer Type",
  COUNTRY: "Country",
  ADDRESS: "Address",
  PIN_CODE: "Pin Code",
  CITY: "City",
  STATE: "State",
  LOAN_AMOUNT: "Loan Amount",
  TENURE: "Tenure",
  EMI: "EMI",
  PRE_EMI: "Pre-EMI",
  RATE_OF_INTEREST: "Rate of Interest",
  PROCESSING_FEE: "Processing Fee",
  OFFER_DETAILS: "Offer Details",
  DISBURSED_ON: "Disbursed On",
  PAYMENT_DETAILS: "Payment Details",
  RESTRUCTURED: "Restructured",
  SEND_PAYMENT_LINK: "Send Payment Link",
  RESEND_LINK: "Resend Link",
  TOTAL_DUES: "Total Dues",
  OVERDUE_PRINCIPAL: "Overdue Principal",
  OVERDUE_INTEREST: "Overdue Interest",
  TOTAL_OUTSTANDING: "Total Outstanding",
  PRE_APPROVED_AMOUNT: "Pre-approved amount",
  TOTAL_POS: "Total POS",
  TOTAL_DUES_PENALTIES: "Total Dues+Penalties",
  OUTSTANDING_PENALTIES: "Outstanding penalties",
  TOTAL_AMOUNT_DUE: "Total Amount Due(billed+unbilled+penalties)",
  PAYMENT: "Payment Cycle",
  LAST_PAID_ON: "Last Paid On",
  MODE_OF_PAYMENT: "Last Mode of Payment",
  NACH_STATUS: "NACH Status",
  FIRST_EMI: "First EMI",
  EMI_DUE_ON: "EMI Due on",
  PAYMENT_CYCLE: "Payment Cycle",
  DELINQUENCY_DETAILS: "Delinquency Details",
  VIEW_BOUNCE_REASON: "View Bounce Reason",
  LATEST_BOUNCE_REASON: "Latest Bounce Reason",
  NACH_BOUNCES: "NACH Bounces",
  EMI_OVERDUE: "EMI Overdue",
  DISPOSITION_DETAILS: "Dispositions Details",
  CONTACT_TYPE: "Contact type",
  PEAK: "Peak",
  OUTCOME: "Outcome",
  PAYMENT_PROMISES: "Payment Promises",
  PTP_BROKEN: "PTP Broken",
  PTP_AMOUNT: "PTP Amount",
  PTP_DATE: "PTP Date",
  LENDING_PARTNER: "Lending Partner",
  LAST: "Last",
  DISPOSITION: "Disposition",
  AGENT: "Agent",
  CUSTOMERS_SELECTED: "Customers Selected",
  SELECTED_CUSTOMER: "Selected Customer",
  RE_ALLOCATE_AGENT: "RE-ALLOCATE AGENT",
  VALIDATE: "Validate",
  EDIT: "Edit",
  BULK_ALLOCATION: "Bulk Allocation",
  UPLOAD_CSV_HEADER_ALLOC: "Upload CSV file for bulk allocation of agents",
  BULK_FEEDBACK: "Bulk Feedback",
  UPLOAD_CSV_HEADER_FEEDBACK: "Upload CSV file for bulk feedback of customers",
  ALLOCATE_AGENT: "ALLOCATE AGENT",
  VALIDATE_CAMEL_CASE: "VALIDATE",
  EMI_DETAILS: "EMI Details",
  CHANGE: "CHANGE",
  LAN: "LAN",
  LAST_CLOSED_LAN: "Last Closed LAN",
  NEW_MAILS: "New Mails",
  REJECT: "REJECT",
  ACCEPT: "ACCEPT",
  PARTNER_NAME: "Partner Name",
  PARTNER_BUREAU_STATUS: "Partner Bureau Status",
  RAZORPAY: "Razorpay",

  // CRM page
  FEEDBACK_SAVE_SUCCESS: "Your feedback is submitted successfully!",

  // foreclosure
  FORECLOSURE_DATE: "Foreclosure Date",
  OUTSTANDING_PRINCIPAL: "Outstanding Principal",
  OVERDUE_EMI_PAYMENTS: "Overdue EMI Payments",
  OUTSTANDING_INTEREST: "Outstanding Interest",
  PENDING_PENALITIES: "Pending Penalties",
  TOTAL_AMOUNT: "Total Amount",

  //settlement
  SETTLEMENT_DATE: "Settlement Date",
  SETTLEMENT_AMOUNT: "Settlement Amount",
  HIDE_BREAKUP: "Hide Breakup",
  SHOW_BREAKUP: "Show Breakup",
  SETTLEMENT_EXPIRY_DATE: "Settlement Expiry  Date",
  SETTLEMENT_POLICY_APPROVED: "This amount is approved under our policy. You can share the link with the customer.",
  SETTLEMENT_POLICY_NEED_APPROVE: "This amount is NOT approved under our policy. Please share the profile with {{emailId}} for further approval.",

  // crm calling tips
  CALLING_TIPS: "Calling Tips",
  CALL_TYPE: "Call Type",
  CUSTOMER: "Customer",
  CALLING_TIP_DESC: "Please follow checklist below",

  // chat crm
  TIME_REMAINING_TEXT: "Time Remaining for Free Chat",
  OUTSTANDING_AMOUNT: "Outstanding Amount",
  LOAD_MORE_BUTTON_TEXT: "Load More",
  SORT_BY: "Sort By",
  SORT_ACTION_BUTTON_TEXT: "Sort",
  NO_RESULT_TEXT: "No Results Found",
  SEARCH_RESULTS: "Search Results",
  CHAT_ACTIONS: "Chat Actions",
  MAKE_AVAILABLE_BUTTON_TEXT: "Make Available For Others",
  RESOLVED: "Resolve",
  RESOLVED_PL: "Resolve+LAN Select",
  PERSONAL_DETAILS: "Personal Details",
  TUTORIAL_LINKS: "Tutorial Links",
  PAYMENT_LINK: "Payment Link",
  GENERATE_AND_SEND: "Generate & Send",
  FULL_NAME: "Full Name",
  DOCUMENTS: "Documents",
  FILES: "File(s)",
  FAILED_MESSAGE_TEXT: "Failed to send message",
  NO_CHAT_MESSAGE_TEXT: "You Don’t Have Any Selected Chat",
  CHAT_MESSAGE_BOX_PLACEHOLDER: "Enter your message here",
  NO_MORE_CHAT_MESSAGE_TEXT: "No More Messages",
  SUCCESS_ACTION_MESSAGE: "Chat successfully updated!",
  VIEW_MORE_DETAILS: "View More Details",
  SEND_LINK_CONFIRM_TEXT: "Are you sure you want to send the link?",
  SUBSCRIBE: "SUBSCRIBE",
  NACH_DETAILS: "NACH Details",
  PROC_FEE: "Proc. fee",
  TRANSFERABLE_AMOUNT: "Tran. Amount",
  FIRST_EMI_DATE: "First EMI Date",
  ROI: "ROI",
  UDRS_NACH_TITLE: "WhatsApp Support for NACH",
  UDRS_COLLECTION_TITLE: "Collection Portal",
  SUCCESS_UDRS_UPDATE_MESSAGE: "Chat successfully moved to respected UDRS!",
  UDRS_IP_DOC_TITLE: "WhatsApp Support for IP",
  UDRS_MISMATCH_ERROR_CODE: "CHAT_ROOM_MISMATCH",
  UDRS_STATUS_CHANGED_TEXT: "UDRS status moved to next stage! Please refresh.",
  APP_DETAILS: "App Details",
  PENDING_DOCUMENTS: "Pending Docs.",
  REJECT_REASON: "Reject Reason",
  DOC_TYPE: "Doc. Type",

  ON_SAVE_SERVER_ERROR: "On Save Server Error",
  DOWNLOAD_LIST: "Download List",
};
